import React from 'react';
import { Globe2 } from 'lucide-react';
import { useSettings } from '../context/SettingsContext';

/**
 * Footer'daki "güncel giriş adresi" bandı (Operasyon → Giriş Adresleri).
 *
 * Panelde yazılan not (`entry_domain.notice`) ve — yönetici açıkça istediyse
 * (`show_list`) — yedek adreslerin listesi burada görünür. Kurulumun adresi
 * sık değişir ve engellenen adreste kalan oyuncu yeni adresi çoğu zaman
 * sitenin kendisinden öğrenir; bant bu yüzden footer'dadır, her sayfada.
 *
 * Bütün kabuklar (klasik, Merit, Zümrüt, Paris, Herkül, Vega, Betrun) **bu
 * bileşeni** sponsorluk bandının hemen üstünde çizer; renk tema
 * değişkenlerinden türer. Yönetici ne not ne liste verdiyse hiçbir şey
 * çizilmez — bölüm açıldı diye footer'a boş bir bant eklenmez.
 */
export const entryDomainStripModel = (entry) => {
  if (!entry || !entry.enabled) return null;
  const notice = String(entry.notice || '').trim();
  const domains = Array.isArray(entry.domains) ? entry.domains : [];
  const active = String(entry.active_host || '').trim();
  const others = domains
    .map((item) => String(item?.host || '').trim())
    .filter((host) => host && host !== active);
  if (!notice && !others.length) return null;
  return {
    title: notice || 'Güncel giriş adresimiz',
    active,
    activeUrl: /^https?:\/\//i.test(entry.active_url || '') ? entry.active_url : '',
    others,
  };
};

const EntryDomainStrip = ({ className = '' }) => {
  const settings = useSettings();
  const model = entryDomainStripModel(settings.entry_domain);
  if (!model) return null;

  return (
    <div className={`entry-domain-strip ${className}`.trim()}>
      <div className="entry-domain-strip-inner">
        <Globe2 size={16} className="entry-domain-strip-icon" aria-hidden="true" />
        <span className="entry-domain-strip-title">{model.title}</span>
        {model.active && (
          model.activeUrl ? (
            <a className="entry-domain-strip-active" href={model.activeUrl}>
              {model.active}
            </a>
          ) : (
            <span className="entry-domain-strip-active">{model.active}</span>
          )
        )}
        {model.others.length > 0 && (
          <span className="entry-domain-strip-others">
            <span className="entry-domain-strip-label">Yedek adreslerimiz:</span>
            {model.others.map((host) => (
              <a key={host} href={`https://${host}`} className="entry-domain-strip-host">
                {host}
              </a>
            ))}
          </span>
        )}
      </div>
    </div>
  );
};

export default EntryDomainStrip;
